<template>
	<!-- eslint-disable vue/no-use-v-if-with-v-for,vue/no-confusing-v-for-v-if -->
	<b-row if="value">
		<b-col class="attachments-wrapper" v-if="value.attachment">
			<b-row >
				<b-col lg="4" class="attachment"   v-for=" (m, mindex) in value.attachment" :key="'mindex'+mindex">
					<div class="attachment__border">

					<b-link v-if="isImage(m.fileType)"  href="#" @click="showPhotoSwipe(mindex)">
						<div class="square-box">
							<div class="square-content" :style="'background-image:url('+thumbnailLink(m)+');'"></div>
						</div>
					</b-link>
					<div class="attachment__details">
						<template v-if="m.sourceTable == null">
							<b-alert :show="true" variant="warning">
								<strong><font-awesome-icon icon="exclamation-triangle" />&nbsp;&nbsp;File uploaded from change request must be approved.</strong>
							</b-alert>
						</template>
					<div class="attachment__download">
					<div class="attachment__message"  v-show="!isEditingComment(m.id)"><div v-html="m.comments.value"></div><b-button class="pl-0" variant="text" v-show="canEditComment(m.userId)" type="button" @click="editComment(m.id)"><span class="icon-edit"></span> Edit Description</b-button></div>
					<strong>Download: </strong><b-link target="_blank" :href="downloadLink(m)" :download="m.userFilename" class="attachment__link"> <font-awesome-icon :icon="fileIcon(m.fileType)" /><span v-if="m.userFilename != m.comments.value">{{m.userFilename}}</span>
					[{{getFileSize(m.fileSize)}}]</b-link><br/>
					</div>
					<div class="attachment__message" v-show="isEditingComment(m.id)"><wysiwyg iconOverrides="bold" v-model="m.comments.value" ></wysiwyg><b-button class="mt-2 mb-2" variant="primary" type="button" @click="saveComment(m.id, m.comments.value)"><span class="icon-save"></span> Save Description</b-button></div>
					<div class="attachment__date">{{moment(m.uploadedDate.value).format('MMMM D, Y H:mm:ss')}}</div>
					<div class="attachment__name">{{m.firstName}} {{m.lastName}}, {{m.organizationName}}</div>
					<div class="attachment__source" v-html="getAttachmentSource(m.sourceTable, m.sourceId)"></div>
					<div class="attachment__delete" v-show="hasPermissionToDeleteAttachment(m)">
						<b-button class="mt-2 mb-2" variant="primary" type="button" @click="openConfirmationModal(m)" 
						title="Delete Attachment"><font-awesome-icon icon="trash" /> Delete Attachment</b-button>
					</div>
					</div>
					</div>
				</b-col>
			</b-row>
			<confirmation-modal  ref="confirmationModal" @action-confirmed="deleteAttachment"
				:confirmText="'Deletion of files is irreversible! Are you sure you want to delete this attachment?'"
			></confirmation-modal>
		<p-photoswipe :isOpen="isOpen" :items="items" :options="options" @close="hidePhotoSwipe"></p-photoswipe>
		</b-col>
	</b-row>
</template>

<script>
import BootstrapField from '../utility/BootstrapField';
import { PhotoSwipe } from './p-photoswipe'
import Format from '../utility/Format'
import ConfirmationModal from './ConfirmationModal.vue';

export default {
	name: 'LaneClosureRequestAttachmentsList',
	components: {
		ConfirmationModal,
	'p-photoswipe': PhotoSwipe
	},
	props: ['value', 'downloadToken', 'downloadTokenExpires'],
	data() {
		return {
			comments: new BootstrapField({
			}),
			isOpen: false,
			isOpenGallery: false,
			editAttachmentId: null,
			options: {
				index: 0
			},
			attachmentToDelete: null,
		}
	},
	mounted() {
   },
   watch: {
   },
	computed: {
		items() {
			let listItem = [];
			if (this.value) {
				if (this.value.attachment) {
					let x = 0;
					for (x = 0; x < this.value.attachment.length; x++) {
						if (this.isImage(this.value.attachment[x].fileType) && this.value.attachment[x].thumbnailUrl) {
							listItem.push ({
								src: this.value.attachment[x].fileUrl + "/" + this.downloadToken,
								w: this.value.attachment[x].width,
								h: this.value.attachment[x].height,
								title: this.value.attachment[x].comments.value
							});
						}
					}
				}
			}
			return listItem;
		}

	},
	methods: {
		downloadLink(m) {
			if (m != null) {
				if (m.downloadUrl != null && this.downloadToken != null) {
					return m.downloadUrl + "/" + this.downloadToken;
				}
			}
		},
		thumbnailLink(m) {
			if (m != null) {
				if (m.thumbnailUrl != null && this.downloadToken != null) {
					return m.thumbnailUrl + "/" + this.downloadToken;
				}
			}
		},

		getFileSize(fileSize) {
			return Format.fileSize(fileSize)	;
		},
		isEditingComment(attachmentId) {
			if (this.editAttachmentId == attachmentId) {
				return true;
			}
			return false;
		},
		canEditComment(userId) {
			if ( (this.$store.getters.userId() == userId) ||  // the person that uploaded the file
				(this.$store.getters["laneClosureRequest/userIsRequester"](this.$store.getters.userId()))  ||  // the requester
				this.$store.getters.userHasRole('internal_admin_requests') ||
				this.$store.getters.userHasRole('system_admin')
			) {
				return true;
			}
			return false;
		},
		editComment(attachmentId) {
			if (this.value) {
				if (this.editAttachmentId != null && this.editAttachmentId != attachmentId) {
					// we are already editing one, so let's save it.
					let x = 0;
					for (x = 0; x < this.value.attachment.length; x++) {
						if (this.value.attachment[x].id == this.editAttachmentId) {
							this.$bus.$emit("attachment:updateComment", { attachmentId:this.value.attachment[x].id, comments: this.value.attachment[x].comments.value});
						}
					}
				}
			}
			this.editAttachmentId = attachmentId;
			this.$emit("edit-attachment-comments", attachmentId);
		},
		autoSave() {
			if (this.value) {
				if (this.editAttachmentId != null) {
					let x = 0;
					for (x = 0; x < this.value.attachment.length; x++) {
						if (this.value.attachment[x].id == this.editAttachmentId) {
							this.$bus.$emit("attachment:autoSave", { attachmentId:this.value.attachment[x].id, comments: this.value.attachment[x].comments.value});
						}
					}
					this.editAttachmentId = null;
				}
			}
		},
		saveComment(attachmentId, comments) {
			this.$bus.$emit("attachment:updateComment", { attachmentId:attachmentId, comments: comments});
			this.editAttachmentId = null;
		},
		getAttachmentSource(sourceTable, sourceId) {
			let msg = "";
			if (sourceTable == "r_attachment") {
				msg = "Reported Restriction ID #" + sourceId;
			}
			if (sourceTable == "lc_attachment") {
				msg = "Reported Closure ID #"+ sourceId;
			}
			if (sourceTable == "lcr_attachment") {
				msg = "Lane Closure Request";
			}
			if (sourceTable == "contravention_attachment") {
				msg = "Violation ID #" + sourceId+"";
			}
			return msg;
		},
		showPhotoSwipe (index) {
			this.isOpen = true
			this.$set(this.options, 'index', index)
		},
		hidePhotoSwipe () {
			this.isOpen = false
		},
		hasPermissionToDeleteAttachment(m){
			if (m != null) {
				let lcrStatus = this.value.approvalStatusId.value;
				if ((this.$store.getters.userId() == m.userId && lcrStatus != 2) ||  // the person that uploaded the file can delete it.
					(this.$store.getters["laneClosureRequest/userIsRequester"](this.$store.getters.userId()) && lcrStatus != 2)  ||  // the requester can delete the file if not approved.

					this.$store.getters.userHasRole('internal_admin_requests') ||
					this.$store.getters.userHasRole('system_admin')
				) {
					return true;
				}
			}
			return false;
		},
		openConfirmationModal(m) {
			if (m != null) {
				this.attachmentToDelete = m;
				this.$refs.confirmationModal.openModal();
			}
		},
		deleteAttachment() {
			this.$bus.$emit("attachment:delete", { 
				attachmentId:this.attachmentToDelete.id,
				userId: this.attachmentToDelete.userId,
				sourceTable:this.sourceTable,
				sourceId:this.sourceId
			});
		},
		isImage(fileType) {
			if (fileType == 'png' || fileType == 'jpg' || fileType == 'jpeg') {
				return true;
			}
			return false;
		},
		fileIcon(fileType) {
			let icon = ['far', 'file'];
			if (fileType == 'png' || fileType == 'jpg' || fileType == 'jpeg') {
				icon = ['far',"file-image"]
			}
			if (fileType == 'xls' || fileType == 'xlsx') {
				icon = ['far',"file-excel"]
			}
			if (fileType == 'pdf' ) {
				icon = ['far',"file-pdf"]
			}
			if (fileType == 'ppt' || fileType == 'pptx' ) {
				icon = ['far',"file-powerpoint"]
			}
			if (fileType == 'doc' || fileType == 'docx' ) {
				icon = ['far',"file-word"]
			}
			if (fileType == 'mpg' || fileType == 'mp4'|| fileType == 'mpeg'|| fileType == 'avi' ) {
				icon = ['far',"file-video"]
			}

			return icon;
		}
	}
}
</script>
